declare var dataLayer: {
  push: Function,
};

export default (category: string = '', action: string = '', label: string = '') => {
  dataLayer.push({
    event: 'general_event',
    general_event_category: category,
    general_event_action: action,
    general_event_label: label,
  });
};
